import Factory from './utils/factory'
import Address from './Address'

export default Factory({
  company: null,
  organizationNumber: null,
  address: Address(),
  email: null,
})
